// @ts-nocheck
import wowImageFactory from './WowImage';
export default function init(contextWindow) {
    const elementName = 'wow-image';
    contextWindow = contextWindow || window;
    if (contextWindow.customElements.get(elementName) === undefined) {
        let resizeObserver;
        if (contextWindow.ResizeObserver) {
            resizeObserver = new contextWindow.ResizeObserver((entries) => entries.map((entry) => entry.target.reLayout()));
        }
        let intersectionObserver;
        if (contextWindow.IntersectionObserver) {
            intersectionObserver = new IntersectionObserver((entries, observer) => entries.map((entry) => {
                const wowImage = entry.target;
                if (entry.isIntersecting) {
                    wowImage.unobserveIntersect();
                    // resize Observe will invoke relayout imidiatly.
                    // "Observation will fire when observation starts if Element is being rendered, and Element’s size is not 0,0,"
                    // https://drafts.csswg.org/resize-observer/#dom-resizeobserver-observe
                    wowImage.observeResize();
                }
                return entry;
            }), { rootMargin: '50% 0px' });
        }
        return function (services, env) {
            const WowImage = wowImageFactory(Object.assign({ resizeService: resizeObserver, intersectionService: intersectionObserver }, services), env, contextWindow);
            contextWindow.customElements.define(elementName, WowImage);
        };
    }
    return;
}
//# sourceMappingURL=registry.js.map